import { render } from "./Lock.vue?vue&type=template&id=757e7cd0&ts=true"
import script from "./Lock.vue?vue&type=script&lang=ts"
export * from "./Lock.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__